import {
  StoreBelowFold,
  StoreRules,
  leadBlock,
} from "@softmax/product-ux/catalog";
import { RulesMarkdown } from "./rules-markdown";
import { buildHref } from "@softmax/web-addresses";
import type { ReactNode } from "react";
import type { PreviewContent } from "../content/preview-content.types";
import { LockedRegion } from "../../store-editor";
import { HowYouPlayDiagram } from "./how-you-play-diagram";
export function StoreBelowFoldContent({
  content,
  beatsSlot,
  fig,
}: {
  content: PreviewContent;
  beatsSlot?: ReactNode;
  fig?: "a" | "b" | undefined;
}) {
  const rules = content.rulesPage;
  let rulesSlot: ReactNode = null;

  if (rules) {
    rulesSlot = (
      <LockedRegion label="Edit via the Wiki">
        <StoreRules
          title={rules.title}
          licenseNotice={content.copy.rulesLicenseNotice}
          body={
            <RulesMarkdown
              body={leadBlock(rules.body)}
              basePath={buildHref({
                name: "game.wiki",
                game: content.route.game,
              })}
            />
          }
        />
      </LockedRegion>
    );
  }

  return (
    <StoreBelowFold
      beats={content.copy.play.beats}
      beatsSlot={beatsSlot}
      diagramSlot={
        <LockedRegion label="Live data, updated automatically">
          <HowYouPlayDiagram content={content} fig={fig} />
        </LockedRegion>
      }
      rulesSlot={rulesSlot}
    />
  );
}
